/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoRosreestrIcon20Regular = forwardRef('GovKoRosreestrIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 7.5a6.5 6.5 0 1 1 7.484 6.426A5.5 5.5 0 0 1 6 19H4.75a.75.75 0 0 1-.75-.75V7.5ZM5.525 7A5.002 5.002 0 0 1 10 2.525V7H5.525ZM5.5 13V8H10v5H5.5Zm0 1v3.5H6A4 4 0 0 0 9.969 14H5.5Zm9.975-6A5.002 5.002 0 0 1 11 12.475V8h4.475ZM11 2.525A5.002 5.002 0 0 1 15.475 7H11V2.525Z" })));
});
